import React, { FC } from "react";
import { Box, IconButton } from "@mui/material";
import SvgEdit from "./editIcon";
import SvgDeleteIcon from "./deleteIcon";

export interface ButtonEvents {
  editEvent: Function;
  deleteEvent: Function;
  eMarkerId: number;
}

export const EditDeletIcons: FC<ButtonEvents> = (props) => {
  const {
    editEvent,
    deleteEvent,
    eMarkerId
  } = props;

  return (
    <Box display={"flex"} justifyContent="right">
        <IconButton aria-label="edit"  onClick={() => {editEvent(eMarkerId) }} >
          <SvgEdit color="secondary" fontSize="inherit"/>
        </IconButton>
        <IconButton aria-label="delete"  onClick={() => {deleteEvent(eMarkerId) }}>
          <SvgDeleteIcon color="secondary" fontSize="inherit" />
        </IconButton>
    </Box>
  );
};
export default EditDeletIcons;
